import * as React from 'react';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import Typography from '@mui/material/Typography';
import { Box, Stack } from '@mui/material';
import { IGaugePanel, ILabelValuePanel } from '../Dashboard.model';
import { LayoutItem } from 'react-grid-layout';
import LabelValuePanel from '../LabelValuePanel/LabelValuePanel';

interface GaugePanelProps {
  panel: IGaugePanel;
  layout?: LayoutItem | undefined;
}

export default function GaugePanel(props: GaugePanelProps) {
  const { panel, layout } = props;
  const { gaugeProps, icon, labelValueActive, labelValueInactive } = panel;
  const isSmall = layout ? layout?.w <= 2 || layout.h <= 1 || !icon : !icon; // Example condition for small size, adjust as needed

  const chart = (
    <Gauge
      {...gaugeProps}
      sx={{
        // make it look like the big donut
        [`& .${gaugeClasses.valueText}`]: {
          fontSize: 28,
          fontWeight: 800,
        },
        [`& .${gaugeClasses.valueArc}`]: {
          fill: '#377e22',
        },
        [`& .${gaugeClasses.referenceArc}`]: {
          fill: '#c0c0c0',
        },
      }}
    />
  );

  const content = isSmall ? (
    chart
  ) : (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="space-between"
      display={'flex'}
      height={'100%'}
      pb={1}
    >
      {/* Gauge block */}
      <Box
        sx={{
          height: 'calc(100% - 1em)',
          maxWidth: '100%',
          width: '100%',
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Simple */}
        {chart}
      </Box>
      {/* Legend */}
      <Stack direction="row" justifyContent="center" spacing={2} px={1}>
        {labelValueActive && (
          <Stack direction="row" spacing={1} alignItems="center">
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: '#377e22',
              }}
            />
            <Typography sx={{ fontSize: 12 }}>{labelValueActive}</Typography>
          </Stack>
        )}

        {labelValueInactive && (
          <Stack direction="row" spacing={1} alignItems="center">
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: '#c0c0c0',
              }}
            />
            <Typography sx={{ fontSize: 12 }}>{labelValueInactive}</Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
  const labelPanel: ILabelValuePanel = {
    ...panel,
    type: 'LABEL_VALUE',
    content: content,
  };

  return <LabelValuePanel panel={labelPanel} layout={layout} />;
}
